<template>
  <div>
    <div v-if="!isMobile">
      <v-speed-dial
        v-model="fab"
        :direction="direction"
        :open-on-hover="hover"
        :transition="transition"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" fab icon small title="عملیات">
            <v-icon v-if="fab" color="pink darken-1">mdi-close</v-icon>
            <v-icon v-else>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-btn
          v-for="(item, index) in meta.buttons"
          v-show="item.condition ? validation(item) : true"
          :key="index"
          v-status="item.status"
          :class="classBtn + item.class"
          :href="data[item.link]"
          :tag="item.hasOwnProperty('link') && !!item.link ? 'a' : 'div'"
          :title="item.label"
          fab
          small
          target="_blank"
          @click="item.action(data, item.name)"
        >
          <i :class="iconClass + item.icon"></i>
          <v-icon v-if="item.icon === 'refresh'" class="fresh" color="red"
            >mdi-refresh</v-icon
          >
        </v-btn>
      </v-speed-dial>
    </div>
    <div v-else cols="12">
      <div class="mob-btn">
        <v-btn
          v-for="(item, index) in meta.buttons"
          v-show="item.condition ? validation(item) : true"
          :key="index"
          :class="classBtn + item.class"
          :title="item.label"
          class="m-1 col-5"
          small
          v-status="item.status"
          @click="item.action(data, item.name)"
        >
          <i :class="iconClass + item.icon"></i>
          <v-icon v-if="item.icon === 'refresh'" class="fresh" color="red"
            >mdi-refresh</v-icon
          >
          {{ item.label }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "buttons",
  props: {
    data: {},
    action: {
      type: Function,
    },
    meta: {
      type: Object,
    },
  },
  data() {
    return {
      classBtn: "btn btn-sm text-center ",
      iconClass: "px-1 text-center fa fa-",
      direction: "right",
      color: {
        edit: "warning",
        delete: "error",
        show: "info",
        refresh: "indigo",
      },
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-x-reverse-transition",
    };
  },
  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },
  methods: {
    validation(item) {
      if (this.data.payment || this.data.renew) {
        return item.condition(
          this.data.payment || this.data.renew,
          this.data,
          this
        );
      } else if (this.data.deleted_at) {
        return item.condition(this.data.deleted_at, this.data, this);
      } else if (
        this.data.owner_id ||
        this.data.total_post ||
        Object.hasOwn(this.data, "owner_id")
      ) {
        return item.condition(this.data.owner_id, this.data, this);
      } else if (this.data.data) {
        return item.condition(
          this.data.data.status || this.data.status,
          this.data,
          this
        );
      } else {
        return true;
      }
    },
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
      }
    },
  },
};
</script>
<style>
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}

i.v-icon.fresh:hover {
  color: white !important;
}
.mob-btn {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
  justify-content: center !important;
  padding-left: 0px;
  padding-right: 0px;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap !important;
  gap: 5px !important;
}

/* .mob-btn .v-btn {
  margin: 3px !important;
} */
.mob-btn {
  overflow-y: auto;
  min-height: 100%;
}
</style>
